// enums
export enum ProfileEnum {
 firstName= "firstName",
 lastName = "lastName",
 title = "title",
 email = "email",
 workPhone = "workPhone",
 mobilePhone = "mobilePhone",
 icon = "icon",
 newPassword1= "newPassword1",
 newPassword2 = "newPassword2",
 oldPassword = "oldPassword",
}

export enum CapabilityCategoriesEnum  {
   integration = "integration",
   application = "application",
   link = "link",
}

export enum IntegrationStatusEnum {
 reAuthenticate = "reAuthenticate",
 deActivated = "deActivated",
 activated = "activated",
 activate = "activate", 
}

export enum CapabilityPlatformTypesEnum   {
   salesforce_native = 'salesforce_native',
   ms_dynamics_native = 'ms_dynamics_native',
   iphone_application = 'iphone_application',
   ipad_application = 'ipad_application',
   android_application = "android_application",
   windows_application = 'windows_application',
   android_tablet = 'android_tablet',
   chrome_extension = 'chrome_extension',
   outlook_addin = 'outlook_addin',
}

export const applicationPlatformTypes  = [
    CapabilityPlatformTypesEnum.iphone_application,
    CapabilityPlatformTypesEnum.ipad_application,
    CapabilityPlatformTypesEnum.android_application, 
    CapabilityPlatformTypesEnum.android_tablet,
    CapabilityPlatformTypesEnum.windows_application, 
];

export const externalLinkTypes  = [
   CapabilityPlatformTypesEnum.chrome_extension, 
   CapabilityPlatformTypesEnum.outlook_addin,
   CapabilityPlatformTypesEnum.salesforce_native,
   CapabilityPlatformTypesEnum.ms_dynamics_native, 
];

export const adminOnlyCapabilityTypes = [
   CapabilityPlatformTypesEnum.salesforce_native, 
   CapabilityPlatformTypesEnum.ms_dynamics_native
]

export const externalLinksMapping = {
    [CapabilityPlatformTypesEnum.chrome_extension]: "https://chromewebstore.google.com/detail/gghdahjgeomeiohiecmfmdomeighihih?utm_source=item-share-cb",
    [CapabilityPlatformTypesEnum.outlook_addin]: "https://appsource.microsoft.com/en-us/product/office/WA200001473",
    [CapabilityPlatformTypesEnum.ms_dynamics_native]: "https://appsource.microsoft.com/en-us/product/dynamics-365/paperfliteinc1652251834907.15072022",
    [CapabilityPlatformTypesEnum.salesforce_native]: "https://login.salesforce.com/packaging/installPackage.apexp?p0=04tJ30000004eJj",
}

export const applicationQRCodeMapping = {
    [CapabilityPlatformTypesEnum.android_application]: "https://play.google.com/store/apps/details?id=com.paperflite.v2&hl=en_IN",
    [CapabilityPlatformTypesEnum.android_tablet]: "https://play.google.com/store/apps/details?id=com.paperflite.v2&hl=en_IN",
    [CapabilityPlatformTypesEnum.ipad_application]: "https://apps.apple.com/in/app/paperflite/id6499001217",
    [CapabilityPlatformTypesEnum.iphone_application]: "https://apps.apple.com/in/app/paperflite/id6499001217",
    [CapabilityPlatformTypesEnum.windows_application]: "https://apps.microsoft.com/detail/9msxpp4gkb07?hl=en-US&gl=IN",
}

export const newVersionAvailableInfo = {
   [CapabilityPlatformTypesEnum.android_application]:{
      version: "1.5",
      qrLink: "https://play.google.com/store/apps/details?id=com.paperflite.v2&hl=en_IN",
      deviceName: "Android Application"
   },
   [CapabilityPlatformTypesEnum.iphone_application]:{
      version: "2.2",
      qrLink: "https://apps.apple.com/in/app/paperflite/id6499001217",
      deviceName: "IPhone Application"
   },
}

// interface's
export interface profileDetails {
   [ProfileEnum.firstName]?: string;
   [ProfileEnum.lastName]?: string;
   [ProfileEnum.title]?: string;
   [ProfileEnum.email]?:  string;
   [ProfileEnum.workPhone]?: string;
   [ProfileEnum.mobilePhone]?:  string;
   [ProfileEnum.icon]?:  string | null;
}

export interface resetPassword {
   [ProfileEnum.newPassword1]: string;
   [ProfileEnum.newPassword2]: string;
   [ProfileEnum.oldPassword]: string;
}


// labels
export const resetPasswordErrorLabels =  {
   [ProfileEnum.newPassword1]: "new password",
   [ProfileEnum.newPassword2]: "re-enter password",
   [ProfileEnum.oldPassword]: "old password",
}
